export default function useResponseParser() {
    const parseSuccessResponseData = (response: any) => {
        return response?.data?.Data;
    };

    const parseErrorResponseData = (error: any) => {
        if (!error) return null;

        // Handle string errors
        if (typeof error === "string") return error;

        // Handle Error objects
        if (error instanceof Error && !("status" in error || "response" in error)) {
            return error.message;
        }

        // Defensive: check for Axios response data
        const responseData = error?.response?.data;
        console.log(responseData);

        if (!responseData) {
            // Fallback for standard status codes if no body is present
            const status = error?.response?.status;
            if (status === 401) return "Unauthorized. Please log in again.";
            if (status === 403) return "You don't have permission to perform this action.";
            if (status === 404) return "The requested resource was not found.";
            if (status === 400) return "Bad request. Please check your input.";
            if (status === 500) return "Server error. Please try again later.";
            return error?.message || "An unexpected error occurred";
        }

        // Standard API error structure from backend
        if (responseData.Error) {
            // Case 1: Array of errors (e.g. express-validator)
            if (Array.isArray(responseData.Error)) {
                return responseData.Error.map((err: any) => {
                    const field = err.param || err.path;
                    return field ? `${field}: ${err.msg}` : err.msg;
                }).join(", ");
            }

            // Case 2: Error object with Message
            if (typeof responseData.Error === "object") {
                return responseData.Error.Message || responseData.Error.message || JSON.stringify(responseData.Error);
            }

            // Case 3: Simple string error
            return responseData.Error;
        }

        // Fallback for other message keys
        if (responseData.message) return responseData.message;

        return "An unknown error occurred";
    };

    return { parseSuccessResponseData, parseErrorResponseData };
}
